// extracted by mini-css-extract-plugin
module.exports = {"cls1":"Layout-Brand-astroturf-module--cls1--26gzU","cls2":"Layout-Brand-astroturf-module--cls1--26gzU Layout-Brand-astroturf-module--cls2--3HcII"};